module.exports = __webpack_public_path__ + "images/sprites/ui/arrow_bu_3dce815f402192cc223fa64636e60c0c.png";